import { BaseModel } from '@/api/base-model'
import { BranchOperatingZoneAPI, PipelineAPI } from '@/api/backend-client'
import { Branch } from '@/api/model/branch'
import { Pipeline } from '@/api/model/pipeline'

export class BranchOperatingZone extends BaseModel<BranchOperatingZone> {
    protected collectionName = BranchOperatingZoneAPI.collectionName

    constructor(
        public pipeline: Pipeline,
        public branch: Branch,
        public id: string,
        public areaCode: number,
    ) { super(id) }

    static fromData(data: any): BranchOperatingZone {
        if (data === null || typeof data === 'string' || data instanceof BranchOperatingZone) {
            return data
        }

        return new BranchOperatingZone(
            data.pipeline ? Pipeline.fromData(data.pipeline) : null,
            data.branch ? Branch.fromData(data.branch) : null,
            data.id,
            data.areaCode,
        )
    }
}
